import React from 'react';
import { Row, Col, Tag, Avatar, Select } from 'antd';
import { ClassificationResult as ClassificationResultType } from '../../types';
import { Icon } from '@ant-design/compatible';
import { SectionTitle } from '../../components/text/Titles';
import { Section } from '../../components/Section';

const { Option } = Select;

type Props = {
  readOnly?: boolean;
  result: null | ClassificationResultType;
  classes: string[];
  onClassChange: (classes: string) => any;
};
export const ClassificationResult = ({ result, readOnly, classes, onClassChange }: Props) => {
  return (
    <div className="w-full">
      <Section className="mt-5">
        <SectionTitle>
          {'Classification'} {readOnly ? ' result' : ''}
        </SectionTitle>
      </Section>
      {readOnly ? (
        <Row
          style={{
            display: 'flex',
            padding: '10px 20px',
            borderBottom: '1px solid #e8e8e8',
          }}>
          <Col span={3}>
            <Avatar
              shape="square"
              icon={
                <Icon
                  type={result && result.reliable ? 'check' : 'minus'}
                  style={{
                    color: result && result.reliable ? '#52c41a' : '#fa541c',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                  }}
                />
              }
              style={{
                backgroundColor: result && result.reliable ? '#d9f7be' : '#ffccc7',
                cursor: 'pointer',
              }}
            />
          </Col>
          <Col span={10} style={{ display: 'flex', alignItems: 'center' }}>
            <span>Class</span>
          </Col>
          <Col
            span={10}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}>
            <Tag style={{ fontSize: 15, padding: '5px 10px' }}>{(result && result.name) || 'Unknown'}</Tag>
          </Col>
        </Row>
      ) : (
        <Row style={{ padding: '10px 20px', borderBottom: '1px solid #e8e8e8' }}>
          <Col span={24}>
            <p>Select the correct class:</p>
          </Col>
          <Col span={24}>
            <Select style={{ width: 200 }} value={result ? result.name : undefined} onChange={onClassChange}>
              {classes.map(className => (
                <Option key={className} value={className}>
                  {className}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      )}
    </div>
  );
};
